module.exports = __webpack_public_path__ + "img/mapa.417d0b48.png";